<section class="section-title">

    <h1 i18n="@@reset_password_title">Reset password</h1>
  
  </section>
  
  <section>
  
    <div class="control-card-white no-border" id="reset-password-card">
  
      <img class="reset-password-logo" src="assets/img/logo_1control.svg"/>
  
      <div class="control-card-content">

        <div *ngIf="!resetSent">

            <p i18n="@@reset_password_message">Se hai dimenticato la password puoi effettuarne il reset inserendo qui il tuo indirizzo email:</p>
    
            <br /><br />

            <label for="userEmail" i18n="@@reset_password_email">Indirizzo email</label>
            <input id="userEmail" type="email" placeholder="Email" #userEmail required autofocus (keyup.enter)="resetPassword(userEmail.value)">
    
            <br /><br />
    
            <a (click)="resetPassword(userEmail.value)" class="button float-left">
                <ng-container i18n="@@reset_password_reset">Reimposta password</ng-container> <span><fa-icon icon="sign-in-alt"></fa-icon></span>
            </a>

            <p class="text-small text-error margin-top-10 margin-left-20 float-left" *ngIf="wrongEmail" > 
                <ng-container i18n="@@reset_password_wrong_email">Email non valida</ng-container>
            </p>

            <p class="text-small text-error margin-top-10 margin-left-20 float-left" *ngIf="emailNotFound" > 
                <ng-container i18n="@@reset_password_email_not_found">L'email inserita non risulta registrata</ng-container>
            </p>

        </div>

        <div *ngIf="resetSent">

            <p i18n="@@reset_password_sent">Ti abbiamo inviato una email con le istruzioni per il reset della password.</p>

            <br /><br />

            <a routerLink="/login" class="button float-left">
                <ng-container i18n="@@reset_password_back">Torna indietro</ng-container> <span><fa-icon icon="arrow-left"></fa-icon></span>
            </a>
    
        </div>
  
      </div>
   
      <app-loading-screen #resetpswloader [loading]="false" ></app-loading-screen>
  
    </div>
  
  </section>